import { render, staticRenderFns } from "./DetailCell.vue?vue&type=template&id=1dfe310d&scoped=true&"
import script from "./DetailCell.vue?vue&type=script&lang=js&"
export * from "./DetailCell.vue?vue&type=script&lang=js&"
import style0 from "./DetailCell.vue?vue&type=style&index=0&id=1dfe310d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.2_uesoswnqfrvbmgjykhrr3r374i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfe310d",
  null
  
)

export default component.exports